(function () {
  if (window.CXKVariantCardSlideshow) return;
  window.CXKVariantCardSlideshow = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function start(card) {
    if (!card || card.dataset.cxkVariantStarted === '1' || reduceMotion) return;
    var slides = [].slice.call(card.querySelectorAll('.cxk-card-variant-slide'));
    if (slides.length < 2) return;

    card.dataset.cxkVariantStarted = '1';
    var current = 0;

    function advance() {
      if (card.dataset.cxkVariantVisible !== '1' || document.hidden) return;
      var previous = slides[current];
      var nextIndex = (current + 1) % slides.length;
      var next = slides[nextIndex];

      previous.classList.remove('cxk-is-active');
      previous.classList.add('cxk-is-prev');
      next.classList.remove('cxk-is-prev');
      next.classList.add('cxk-is-active');

      window.setTimeout(function () {
        previous.classList.remove('cxk-is-prev');
      }, 700);
      current = nextIndex;
    }

    card._cxkVariantInterval = window.setInterval(advance, 3400);
  }

  function prepare(card) {
    if (!card || card.dataset.cxkVariantPreparing === '1' || card.dataset.cxkVariantReady === '1') return;
    var media = card.querySelector('.cxk-variant-slideshow-media');
    if (!media) return;

    var slides = [].slice.call(media.querySelectorAll('.cxk-card-variant-slide'));
    if (slides.length < 2) return;
    card.dataset.cxkVariantPreparing = '1';

    var extras = slides.slice(1);
    extras.forEach(function (image) {
      image.loading = 'eager';
    });

    Promise.all(extras.map(function (image) {
      return new Promise(function (resolve) {
        if (image.complete) {
          resolve(image.naturalWidth > 0 ? image : null);
          return;
        }
        image.addEventListener('load', function () { resolve(image); }, { once: true });
        image.addEventListener('error', function () { resolve(null); }, { once: true });
      });
    })).then(function (loadedExtras) {
      if (!document.documentElement.contains(card)) return;
      extras.forEach(function (image, index) {
        if (!loadedExtras[index]) image.remove();
      });

      slides = [].slice.call(media.querySelectorAll('.cxk-card-variant-slide'));
      if (slides.length < 2) return;
      slides.forEach(function (slide, index) {
        slide.classList.toggle('cxk-is-active', index === 0);
        slide.classList.remove('is-active', 'is-prev', 'cxk-is-prev');
      });
      card.dataset.cxkVariantReady = '1';
      start(card);
    });
  }

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var card = entry.target;
        card.dataset.cxkVariantVisible = entry.isIntersecting ? '1' : '0';
        if (entry.isIntersecting) prepare(card);
      });
    }, { rootMargin: '180px 0px', threshold: 0.05 });
  }

  function initCard(card) {
    if (!card || card.dataset.cxkVariantRegistered === '1') return;
    var media = card.querySelector('.cxk-variant-slideshow-media');
    if (!media || media.querySelectorAll('.cxk-card-variant-slide').length < 2) return;
    card.dataset.cxkVariantRegistered = '1';
    card.dataset.cxkVariantVisible = observer ? '0' : '1';
    if (observer) observer.observe(card);
    else prepare(card);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('.product-card-wrapper')) initCard(scope);
    [].slice.call(scope.querySelectorAll('.product-card-wrapper')).forEach(initCard);
  }

  function boot() {
    scan(document);
    var mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        [].slice.call(mutation.addedNodes || []).forEach(function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });
    });
    mutationObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();

